// @flow
import FilesPreview from './FilesPreview';

export default FilesPreview;
